import { SpaLogger } from 'Public_old/src/app/Common/Classes/Global/spalogger.class';
import { Helper } from 'Public_old/src/app/Common/Helpers/helper';
import { AudioPlayerService } from 'Public_old/src/app/Common/Services/audioPlayer.service';
import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { environment } from 'Public_old/src/environments/environment';
import { Router } from '@angular/router';
import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';
import { SpaContext } from '../../Classes/spacontext';
import { DropInQueueService } from './dropin-queue.service';

export class DropInQueueWebSocket {
	conn: xsockets.client;
	ws: xsockets.controller;
	connectionNotificatioTimern: number | null = null;
	connectionNotification: HTMLElement | null = null;

	constructor(
		private router: Router,
		private spaLogger: SpaLogger,
		private queueContext: DropInQueueService,
		private _audioPlayerService: AudioPlayerService,
		// biome-ignore lint/suspicious/noExplicitAny: Should refactor
		private ticket: any,
		public _spaContext: SpaContext,
		private translateService: TranslateService,
		private helper: Helper,
	) {}

	init() {
		this.conn = new xsockets.client(
			`wss://${environment.production ? location.hostname : environment.realtime.host}:${environment.realtime.port}`,
			['Queue'],
		);
		this.conn.setPersistentId(xsockets.utils.guid());
		this.conn.autoReconnect(false);

		this.conn.onOpen = () => {
			if (this.connectionNotificatioTimern !== null) {
				clearTimeout(this.connectionNotificatioTimern);
				this.connectionNotificatioTimern = null;
			}

			if (this.connectionNotification !== null) {
				this.connectionNotification.remove();
				this.connectionNotification = null;

				this.ws.publish('ping', null); // Ping the server when reconnect, so it know we're back
			}
		};

		this.conn.onClose = () => {
			if (this.connectionNotification !== null || this.connectionNotification !== null) return;

			this.connectionNotificatioTimern = window.setTimeout(() => {
				this.connectionNotificatioTimern = null;
				this.connectionNotification = this.helper.html.persistantNotification({
					Title: navigator.onLine
						? this.translateService.get('Common.Notification.SocketConnectionLost')
						: this.translateService.get('Common.Notification.NotInternetConnection'),
					Description: navigator.onLine ? this.translateService.get('Common.Notification.TryingSocketReconnect') : '',
				});
			}, 5000);

			window.setTimeout(() => {
				this.openSocketConnection();
			}, 1000);
		};

		this.ws = this.conn.controller('queue');

		/*
		 * SocketEvent: Open
		 */
		this.ws.onOpen = () => {
			this.spaLogger.log('Info', ['DropIn', 'Websocket'], 'DropIn_Websocket_Connected');

			window.onunload = () => {
				this.ws.close();
			};
		};

		this.ws.on('duplicate_connection', () => {
			this.ws = null;
			window.onbeforeunload = null;
			window.location.href = `/${µ.LicenceHolder.UrlAlias}/error/multiconnections`;
		});

		/**
		 * SocketEvent: Close
		 */
		this.ws.onClose = () => {
			// Intentionally empty
		};

		/* Custom Events */
		this.ws.on('app_error', (data) => {
			this.queueContext.onAppError();
		});

		this.ws.on('kicked_from_queue', (data) => {
			this.queueContext.onKickedFromQueue();
		});

		/*
		 * Queue info
		 */
		this.ws.on('queue_info', (data) => {
			this.queueContext.queue.setData(data);
			this.queueContext.IH.queueData();
		});

		/*
		 * Dequeued
		 */
		this.ws.on('dequeued', (data) => {
			this._audioPlayerService.stop(`${environment.serverBaseUrl}/assets/ringing.mp3`);

			this.helper.cookie.create('AutoAnswer', 'true', 30 / 86400);

			if (data.unitId === this._spaContext.unitConfig.Unit.UnitId) {
				const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
				this.router.navigate([locationSelectorService.location.route + '/appointment', data.callTicket]);
			} else {
				this.helper.html.loading('show');

				const url = `${this.helper.unit.getUnitUrl(data.unitId, this._spaContext.unitTreeFlat)}/appointment/${data.callTicket}`;
				window.location.href = url;
			}

			this.queueContext.destroy();
		});

		/*
		 * Handshake
		 */
		this.ws.on('handshake_request', (data) => {
			this.spaLogger.log('Debug', ['DropIn', 'Websocket'], 'DropIn_Websocket_HandshakeRequest', data);

			const timeout = data.validForSeconds;
			this.queueContext.queue.handshake(data.handshakeKey, timeout);

			this._audioPlayerService.play(`${environment.serverBaseUrl}/assets/Ring1.mp3`, true);
		});

		/*
		 * Handshake in progress
		 */
		this.ws.on('handshake_in_progress', (data) => {
			const timeout = data.validForSeconds;
			this.queueContext.queue.handshake(data.handshakeKey, timeout);
			this._audioPlayerService.play(`${environment.serverBaseUrl}/assets/Ring1.mp3`, true);
		});

		/*
		 * Handshake timed out
		 */
		this.ws.on('handshake_request_timed_out', (data) => {
			this.spaLogger.log('Debug', ['DropIn', 'Websocket'], 'DropIn_Websocket_HandshakeTimedOut', data);

			this._audioPlayerService.stop(`${environment.serverBaseUrl}/assets/Ring1.mp3`);
			this.queueContext.queue.handshakeFailed();
		});

		/*
		 * Handshake failed
		 */
		this.ws.on('handshake_request_failed', (data) => {
			this.spaLogger.log('Debug', ['DropIn', 'Websocket'], 'DropIn_Websocket_HandshakeFailed', data);
			this._audioPlayerService.stop(`${environment.serverBaseUrl}/assets/Ring1.mp3`);
		});

		this.openSocketConnection();
	}

	openSocketConnection() {
		this.queueContext._dropInService.getTicket(this.ticket).subscribe(
			(response) => {
				this.queueContext.ticketInfo = response.data;
				const creds = {
					ticket: response.data.Ticket,
				};

				const locationSelectorService = sharedResolution.resolve(LocationSelectorService);

				if (!this.queueContext.ticketInfo.MayEnterQueue) {
					this.queueContext._router.navigate([
						locationSelectorService.location.route + '/dropin',
						this.queueContext.ticketInfo.DropInRoomUrlAlias,
					]);

					return;
				}
				this.conn.setParameters(creds);
				this.conn.open();
			},
			(err) => {
				window.setTimeout(() => {
					this.openSocketConnection();
				}, 3000);
			},
		);
	}

	// biome-ignore lint/suspicious/noExplicitAny: Should refactor
	send(type: string, data: any) {
		this.ws.publish(type, data);
	}
}
